import React from 'react';
import useVideoContext from '../../hooks/useVideoContext';
import { MUTE_AUDIO, TURNOFF_VIDEO } from '../../constants';
import { Logger } from '../../utils';

const ParticipantOverlay = ({ identity, isAudioEnabled, isVideoEnabled, setShowRemoveGuestModal }) => {
    const { room } = useVideoContext();
    const [localDataTrackPublication] = [...room.localParticipant.dataTracks.values()];
    const participantRole = identity && identity.split("||") && identity.split("||").length >= 2 && identity.split("||")[2] || "";

    const onVideoClick = (e) => {
        e.stopPropagation();
        if (localDataTrackPublication) {
            localDataTrackPublication.track.send(JSON.stringify({ eventName: TURNOFF_VIDEO, identity }));
            Logger("UI.Twilio.DataTrack.Send.TurnOffVideo", new Date(), { eventName: TURNOFF_VIDEO, identity });
        }
    }

    const onMicClick = (e) => {
        e.stopPropagation();
        if (localDataTrackPublication) {
            localDataTrackPublication.track.send(JSON.stringify({ eventName: MUTE_AUDIO, identity }));
            Logger("UI.Twilio.DataTrack.Send.MuteAudio", new Date(), { eventName: MUTE_AUDIO, identity });
        }
    }

    const onLogoutClick = (e) => {
        e.stopPropagation();         
        setShowRemoveGuestModal(true);
    }     

    return (
        <div className="participant-overlay">
            <div className="icons-container">
                <span className={isVideoEnabled ? "icon-camera" : "icon-camera-off  disabled-style"} disabled={!isVideoEnabled} onClick={onVideoClick} />
                <span className={isAudioEnabled ? "icon-mic" : "icon-mic-off  disabled-style"} disabled={!isAudioEnabled} onClick={onMicClick} />
                {participantRole && participantRole.toLowerCase() === "guest" && <span className="icon-kick-out" onClick={onLogoutClick} />}            
            </div>
        </div>
    );
}

export default ParticipantOverlay;